<div class="course-item" *ngIf="course$ | async as course">
    <div class="item">
        <table>
            <tr>
                <td class="id" *ngIf="course.courseId">{{ course.externalCourseNumber }}</td>
                <td *ngIf="course.title" colspan="7" class="title">
                    <a class="title" a-link [routerLink]="courseDetail">{{ course.title }}</a>
                    <span *ngIf="course.isProduct" [innerHTML]="'courses.online' | translate"></span>
                    <span *ngIf="!course.isProduct" [innerHTML]="'courses.presence' | translate"></span>
                    <div class="vaccination" *ngIf="showVaccinationRules$ | async">
                        <a *ngIf="course && course.vaccinationRule === '2G'" href="javascript:;" (click)="showVaccinationRules(twoG)"
                            ><span>, </span>
                            <span class="link" [innerHTML]="'vaccination.2G.label' | translate"></span>
                        </a>
                        <a *ngIf="course && course.vaccinationRule === '3G'" href="javascript:;" (click)="showVaccinationRules(threeG)"
                            ><span>, </span>
                            <span class="link" [innerHTML]="'vaccination.3G.label' | translate"></span>
                        </a>
                    </div>
                </td>
                <td class="last links">
                    <a da-link [routerLink]="bookingDetails"
                        ><span class="drg-icon-arrow_right"></span><span [innerHTML]="translationPrefix + '.myBooking' | translate"></span
                    ></a>
                </td>
            </tr>
            <tr class="details">
                <td *ngIf="course.infoPackageAvailable && course.infoPackageSubModuleIds.length > 0 && (subModulesAvailable$ | async) && course.status === 'BOOKED'" class="is-infopackage" [ngClass]="course.startDate || (course.location && course.location.city) ? '' : 'mobile'">
                    <div>
                        <strong [innerHTML]="(translationPrefix + '.status' | translate) + ' '"></strong>
                        <ng-container *ngIf="course.status">
                            <span *ngIf="currentStatus">{{ currentStatus.toLowerCase() }}</span>
                        </ng-container>

                        <span class="line" *ngIf="!course.status">-</span>
                    </div>
                </td>
                <td *ngIf="!course.infoPackageAvailable || !(subModulesAvailable$ | async)"></td>
                <td *ngIf="!course.infoPackageAvailable || !(subModulesAvailable$ | async)" class="date" [ngClass]="course.startDate || (course.location && course.location.city) ? '' : 'mobile'">
                    <div>
                        <span *ngIf="course.startDate"
                            ><span [innerHTML]="translationPrefix + '.availableFrom' | translate"></span>
                            <span *ngIf="course.startDate">{{ course.startDate | date: 'dd.MM.yyyy, HH:mm' }}</span></span
                        >
                        <span *ngIf="course.endDate"
                            ><span [innerHTML]="translationPrefix + '.availableTo' | translate"></span>
                            <span *ngIf="course.endDate">{{ course.endDate | date: 'dd.MM.yyyy, HH:mm' }}</span>
                        </span>
                    </div>
                    <div class="city" *ngIf="course.location && course.location.city">
                        <a (click)="openOverlay(course)">{{ course.location.city }}</a>
                    </div>
                </td>
                <td *ngIf="course.infoPackageAvailable && course.infoPackageSubModuleIds.length > 0 && (subModulesAvailable$ | async) && course.status === 'BOOKED'" class="date" [ngClass]="course.startDate || (course.location && course.location.city) ? '' : 'mobile'">
                    <div>
                        <strong [innerHTML]="(translationPrefix + '.result' | translate) + ' '"></strong>
                        <ng-container *ngIf="course.testResult && course.testResult.length > 0">
                            <span *ngIf="testResult">{{ testResult.toLowerCase() }}</span>
                        </ng-container>

                        <span class="line" *ngIf="!course.testResult">-</span>
                    </div>
                </td>
                <td colspan="6" class="results">
                    <div *ngIf="!course.infoPackageAvailable || course.infoPackageSubModuleIds.length === 0 || !(subModulesAvailable$ | async)">
                        <strong [innerHTML]="translationPrefix + '.status' | translate"></strong>
                        <ng-container *ngIf="course.status">
                            <span *ngIf="currentStatus">{{ currentStatus.toLowerCase() }}</span>
                        </ng-container>

                        <span class="line" *ngIf="!course.status">-</span>
                    </div>
                    <div  *ngIf="!course.infoPackageAvailable || course.infoPackageSubModuleIds.length === 0 || !(subModulesAvailable$ | async)">
                        <strong [innerHTML]="translationPrefix + '.result' | translate"></strong>
                        <ng-container *ngIf="course.testResult && course.testResult.length > 0">
                            <span *ngIf="testResult">{{ testResult.toLowerCase() }}</span>
                        </ng-container>

                        <span class="line" *ngIf="!course.testResult">-</span>
                    </div>
                    <div *ngIf="!course.infoPackageAvailable || course.infoPackageSubModuleIds.length === 0 || !(subModulesAvailable$ | async)">
                        <strong [innerHTML]="translationPrefix + '.certificate' | translate"></strong>
                        <span *ngIf="course.certificateUrl"
                            ><a
                                da-link
                                [href]="course.certificateUrl"
                                [innerHTML]="translationPrefix + '.downloadButtonLabel' | translate"
                            ></a
                        ></span>
                        <span class="line" *ngIf="!course.certificateUrl">-</span>
                    </div>
                </td>
                <td class="last buttons">
                    <a
                        *ngIf="course.startPage && (!course.infoPackageAvailable || course.infoPackageSubModuleIds.length === 0 || !(subModulesAvailable$ | async))"
                        [href]="course.startPage"
                        target="_blank"
                        class="button primary"
                        [innerHTML]="translationPrefix + '.startCourse' | translate"
                    ></a>
                    <a
                        da-link
                        [routerLink]="courseDetail"
                        class="button secondary"
                        [innerHTML]="translationPrefix + '.showDetails' | translate"
                    ></a>
                </td>
            </tr>
        </table>
        <da-info-package *ngIf="loggedIn && course.infoPackageAvailable && course.infoPackageSubModuleIds.length > 0 && (subModulesAvailable$ | async) && course.status === 'BOOKED'" [course]="course" [mycourses]="mycourses"></da-info-package>
    </div>
</div>

<ng-template #overlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="location"></ng-container>
    </div>
</ng-template>
<ng-template #location>
    <div class="location-popup" *ngIf="location$ | async as course">
        <div class="title">
            <span [innerHTML]="'common.location' | translate"></span>
        </div>
        <div class="details">
            <span><strong [innerHTML]="'common.address' | translate"></strong></span>
            <span>{{ course.location.name }}</span>
            <span>{{ course.location.street }}</span>
            <span>{{ course.location.city }} {{ course.location.zip }} </span>
            <span>{{ course.location.regionKey }}</span>
            <span>{{ countryName }} ({{ course.location.countryKey }})</span>
            <div><a class="button primary" [innerHTML]="'common.close' | translate" (click)="closeModal()"></a></div>
        </div>
    </div>
</ng-template>

<ng-template #modal>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="edit"></ng-container>
    </div>
</ng-template>
<ng-template #edit>
    <div>
        <div class="title">
            <h2 [innerHTML]="translationPrefix + '.titleEdit' | translate">Location</h2>
        </div>
        <div class="details" [innerHTML]="translationPrefix + '.textEdit' | translate">Lorem ipsum</div>
    </div>
</ng-template>

<ng-template #2G>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="twoGModal"></ng-container>
    </div>
</ng-template>
<ng-template #twoGModal>
    <div class="modal vaccination">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'vaccination.2G.title' | translate"></h3>
                <p [innerHTML]="'vaccination.2G.text' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button primary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #3G>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="threeGModal"></ng-container>
    </div>
</ng-template>
<ng-template #threeGModal>
    <div class="modal vaccination">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'vaccination.3G.title' | translate"></h3>
                <p [innerHTML]="'vaccination.3G.text' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button primary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
